import { Routine } from 'redux-saga-routines';
import { put, takeEvery, all, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { stringify } from 'query-string';
import {
  showPositionProfileModalRoutine,
  showSurveyBuilderModalRoutine,
  showRequestBuilderModalRoutine,
  showContactProfileModalRoutine
} from '../routines/history';
import { IAppState } from '../common/models/store/IAppState';

function* showPositionProfileModal({ payload }: Routine<any>) {
  try {
    const { location } = yield select(({ router }: IAppState) => router);
    yield put(push({
      ...location,
      search: stringify({ positionId: payload }),
      state: { from: location.pathname }
    }));
  } catch (error) {
    yield put(showPositionProfileModalRoutine.failure(error.message));
  }
}

function* showSurveyBuilderModal({ payload }: Routine<any>) {
  try {
    const { location } = yield select(({ router }: IAppState) => router);
    yield put(push({
      ...location,
      search: stringify({ surveyBuilderShown: true, surveyId: payload }),
      state: { from: location.pathname }
    }));
  } catch (error) {
    yield put(showSurveyBuilderModalRoutine.failure(error.message));
  }
}

function* showRequestBuilderModal() {
  try {
    const { location } = yield select(({ router }: IAppState) => router);
    yield put(push({
      ...location,
      search: stringify({ reqBuilderShown: true }),
      state: { from: location.pathname }
    }));
  } catch (error) {
    yield put(showRequestBuilderModalRoutine.failure(error.message));
  }
}

function* showContactProfileModal({ payload }: Routine<any>) {
  try {
    const { location } = yield select(({ router }: IAppState) => router);
    yield put(push({
      ...location,
      search: stringify(payload),
      state: { from: location.pathname }
    }));
  } catch (error) {
    yield put(showContactProfileModalRoutine.failure(error.message));
  }
}

function* watchShowPositionProfileModal() {
  yield takeEvery(showPositionProfileModalRoutine.TRIGGER, showPositionProfileModal);
}

function* watchShowSurveyBuilderModal() {
  yield takeEvery(showSurveyBuilderModalRoutine.TRIGGER, showSurveyBuilderModal);
}

function* watchShowRequestBuilderModal() {
  yield takeEvery(showRequestBuilderModalRoutine.TRIGGER, showRequestBuilderModal);
}

function* watchShowContactProfileModal() {
  yield takeEvery(showContactProfileModalRoutine.TRIGGER, showContactProfileModal);
}

export default function* historySaga() {
  yield all([
    watchShowPositionProfileModal(),
    watchShowSurveyBuilderModal(),
    watchShowRequestBuilderModal(),
    watchShowContactProfileModal()
  ]);
}
